/** All public api keys */
const ApiKeys = {
  /** API key for rapid API url shortener */
  rapidApi: "ae89ffbe94msh172b9c2e24c5ce5p1faebajsn79625c457764"
};
export default ApiKeys;
